import { observable } from "mobx";
import { RootStore } from "./entity.base.store";
import { FirebaseApp, FirebaseOptions, initializeApp } from "firebase/app";
import { deleteToken, getToken, getMessaging, isSupported, onMessage, Messaging } from "firebase/messaging";
import { PushNotificationsConfig } from "../components";
import { savePushToken } from "../api/pushNotifications";
import * as UAParser from "ua-parser-js";

const getDeviceId = () => {
  const screenInfo = window.screen;
  const parser = new UAParser(window.navigator.userAgent);
  const parsedUserAgent = parser.getResult();

  return `${parsedUserAgent.browser.name}-${parsedUserAgent.browser.version}-${screenInfo.width}${screenInfo.height}${screenInfo.colorDepth}`;
}

export default class PushNotificationsStore {
  rootStore: RootStore;
  config: PushNotificationsConfig;
  userId: number | string;
  @observable
  firebaseApplication: FirebaseApp;
  @observable
  firebaseMessaging: Messaging;

  constructor () {

  }

  async getToken (serviceWorkerRegistration: ServiceWorkerRegistration) {
    const currentToken = localStorage.getItem("fbm_tkn");
    const currentTokenUserId = localStorage.getItem("fbm_tkn_userid");

    if (currentTokenUserId && currentTokenUserId != this.userId) {
      try {
        await deleteToken(this.firebaseMessaging);
      } catch (error) {
        console.log("Ошибка удаления токена Firebase Messaging:", error);
      }
    }

    try {
      const newToken = await getToken(this.firebaseMessaging, { vapidKey: this.config.firebaseVAPID, serviceWorkerRegistration: serviceWorkerRegistration });
      if (currentToken !== newToken) {
        const deviceId = getDeviceId();
        try {
          await savePushToken({
            authorization: { 
              authToken: this.config.authToken, 
              host: this.config.host 
            }, 
            payload: { 
              type: "browser", 
              device: deviceId, 
              code: newToken 
            }
          });
          localStorage.setItem("fbm_tkn", newToken);
          localStorage.setItem("fbm_tkn_userid", `${this.userId}`);
        } catch (error) {
          console.log("Не удалось сохранить токен Firebase Messaging:", error);
        }
      }
    
    } catch (error) {
      console.log("Ошибка получения нового токена:", error);
    }
  }


  async init (config: PushNotificationsConfig) {
    const firebaseMessagingIsSupported = await isSupported();
    if (!firebaseMessagingIsSupported) return;

    this.config = config;
    this.userId = config.userId;

    this.firebaseApplication = initializeApp(config.firebaseOptions);
    this.firebaseMessaging = getMessaging(this.firebaseApplication);

    // Если пуши у пользователя включены, то инициализируем приложение и создаем Service Worker,
    // а также получаем токен FCM, который будет отправлен на бэк и сохранен в Local Storage

    // Если же пушки у пользователя отключены, то необходимо удалить токен FCM, удалить токены
    // из Local Storage и разрегистрировать Service Worker

    // TODO: необходимо ли удалять токен у нас на бэке?

    if (config.pushEnabled) {
      try {
        const registration = await navigator.serviceWorker.register(
          `${config.serviceWorker}&firebaseConfig=${JSON.stringify(config.firebaseOptions)}`,
          { scope: '/' }
        );
        await registration.update();
        await navigator.serviceWorker.ready;
        await this.getToken(registration);
      } catch (error) {
        console.log("Ошибка регистрации Firebase Service Worker:", error);
      }

      onMessage(this.firebaseMessaging, async (message) => {
        if ("serviceWorker" in navigator) {
          const registration = await navigator.serviceWorker.getRegistration('/');
          console.log("message in application", message);
          registration.showNotification(message.data.title, {
            body: message.data.body,
            data: message.data
          });
        }
      });
    } else {
      const currentToken = localStorage.getItem("fbm_tkn");
      
      // Удаление токена из Firebase Messaging
      if (currentToken) {
        try {
          await deleteToken(this.firebaseMessaging);
        } catch (error) {
          console.log("Ошибка удаления токена Firebase Messaging:", error);
        }
      }

      // Удаление токена из local storage
      localStorage.removeItem("fbm_tkn");
      localStorage.removeItem("fbm_tkn_userid");

      // Разрегистрирование service workers, связанных с Firebase Messaging
      if ("serviceWorker" in navigator) {
        try {
          const registrations = await navigator.serviceWorker.getRegistrations();
          for (let registration of registrations) {
            registration.unregister();
          }
        } catch (error) {
          console.log("Ошибка удаления Firebase Service Workers:", error);
        }
      }
    }
  }
}